import { ReactNode } from 'react';
import { Box, Typography, Link } from '@mui/material';
import Breadcrumbs, { Props as BreadcrumbsProps } from './Breadcrumbs';
import Iconify from './Iconify';

// ----------------------------------------------------------------------

interface Props extends BreadcrumbsProps {
  action?: ReactNode;
  heading: string;
  moreLink?: string | string[];
  arrowClickBack?: () => void;
}

export default function HeaderBreadcrumbs({
  links,
  action,
  heading,
  arrowClickBack,
  moreLink = [],
  sx,
  ...other
}: Props) {
  return (
    <Box sx={{ mb: 1, ...sx }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ flexGrow: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div
              style={{
                marginRight: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
              }}
              onClick={arrowClickBack}
            >
              <Iconify icon="eva:arrow-ios-back-outline" fontSize="20px" />
            </div>
            <Typography variant="h4">{heading}</Typography>
          </div>

          <Breadcrumbs links={links} {...other} />
        </Box>

        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>

      <Box sx={{ mt: 2 }}>
        {typeof moreLink === 'string' ? (
          <Link href={moreLink} target="_blank" rel="noopener" variant="body2">
            {moreLink}
          </Link>
        ) : (
          moreLink.map((href) => (
            <Link
              noWrap
              key={href}
              href={href}
              variant="body2"
              target="_blank"
              rel="noopener"
              sx={{ display: 'table' }}
            >
              {href}
            </Link>
          ))
        )}
      </Box>
    </Box>
  );
}
